app.factory('paperworkService', [ '$http', function($http) {
    return {
        getByDeparture: function(date){
            return $http.get('/api/paperwork/departure/ ' + _.toString(date))
            .then(res => {
                return res.data
            }, errorHandler)
        }
    };
} ]);
